import React, { useState, useEffect } from "react";
import { Chart } from "react-google-charts";

import { countriesData } from './first-data'


function Explore() {
    let data = []
    let alpha2 = []
    let wrldMapValues = []
    let toolTipCol = []
    let scores = ["..", 0, 1.25, 2.5, 3.75, 5]
    let rankings = ['No Data', 'Very Low', 'Low', 'Medium', 'High', 'Very High']
    let wrldMapTable = [
        [
            'Country',
            'Value',
            {
                type: 'string',
                role: 'tooltip'
            }
        ]
    ]

    const [year, setYear] = useState(2022)
    const [indWorldmap, setindWorldmap] = useState('SEPX')
    const [currentData, setCurrentdata] = useState()
    const [worldMap, setworldMap] = useState()


    useEffect(() => {
        createMap()
    }, [indWorldmap, year])

    const createMap = () => {
        const x = countriesData.filter(element => element["Time"] === +year);
        setCurrentdata(x)

        for (let i = 0; i < x.length; i++) {
            alpha2.push(x[i]['Alpha-2']);
            wrldMapValues.push(x[i][indWorldmap]);
            for (let j = 0; j < rankings.length; j++) {
                if (wrldMapValues[i] === scores[j]) {
                    toolTipCol[i] = rankings[j]
                }
            }
            wrldMapTable.push([alpha2[i], wrldMapValues[i], toolTipCol[i]]);
        }
        // console.log(wrldMapTable)
        setworldMap(wrldMapTable)
        console.log(worldMap)
    }


    const getIdForWrldMap = event => {
        setindWorldmap(event.currentTarget.id)
        createMap()
    };

    const getYear = (e) => {
        setYear(e.target.value)
        createMap()
    }

    const optionmaps = {
        title: 'Region Map',
        colorAxis: {
            colors: ['#802000', '#ff9f80', '#ffff80', '#99e699', '#1e7b1e']
        },
        datalessRegionColor: '#f5fafc',
        defaultColor: '#f5f5f5',
        backgroundColor: { fill: 'transparent' }
    }

    const [selectedOption, setSelectedOption] = useState("Socioeconomic Performance Index");
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);

    const handleOptionSelect = (option) => {
        setSelectedOption(option);
        setIsDropdownOpen(false);
    };
    return (
        <>

            <div className="container mx-auto p-4">
                <div className="flex flex-row items-center space-x-4">
                    <a href="/project">Projects</a>
                    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="16" viewBox="0 0 9 16" fill="none">
                        <path d="M8.275 7.54748L1.30875 0.909985C1.19251 0.799179 1.03808 0.737366 0.877496 0.737366C0.716908 0.737366 0.562482 0.799179 0.446247 0.909985L0.438746 0.917485C0.382203 0.971202 0.337178 1.03586 0.306411 1.10753C0.275644 1.17919 0.259778 1.25637 0.259778 1.33436C0.259778 1.41235 0.275644 1.48953 0.306411 1.56119C0.337178 1.63286 0.382203 1.69752 0.438746 1.75123L6.99875 8.00124L0.438746 14.2487C0.382203 14.3025 0.337178 14.3671 0.306411 14.4388C0.275644 14.5104 0.259778 14.5876 0.259778 14.6656C0.259778 14.7436 0.275644 14.8208 0.306411 14.8924C0.337178 14.9641 0.382203 15.0288 0.438746 15.0825L0.446247 15.09C0.562482 15.2008 0.716908 15.2626 0.877496 15.2626C1.03808 15.2626 1.19251 15.2008 1.30875 15.09L8.275 8.45249C8.33626 8.39411 8.38504 8.32391 8.41836 8.24613C8.45169 8.16834 8.46887 8.08461 8.46887 7.99998C8.46887 7.91536 8.45169 7.83162 8.41836 7.75384C8.38504 7.67606 8.33626 7.60586 8.275 7.54748Z" fill="black" />
                    </svg>
                    <a href="/project">Indonesia Socioeconomic Development</a>
                    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="16" viewBox="0 0 9 16" fill="none">
                        <path d="M8.275 7.54748L1.30875 0.909985C1.19251 0.799179 1.03808 0.737366 0.877496 0.737366C0.716908 0.737366 0.562482 0.799179 0.446247 0.909985L0.438746 0.917485C0.382203 0.971202 0.337178 1.03586 0.306411 1.10753C0.275644 1.17919 0.259778 1.25637 0.259778 1.33436C0.259778 1.41235 0.275644 1.48953 0.306411 1.56119C0.337178 1.63286 0.382203 1.69752 0.438746 1.75123L6.99875 8.00124L0.438746 14.2487C0.382203 14.3025 0.337178 14.3671 0.306411 14.4388C0.275644 14.5104 0.259778 14.5876 0.259778 14.6656C0.259778 14.7436 0.275644 14.8208 0.306411 14.8924C0.337178 14.9641 0.382203 15.0288 0.438746 15.0825L0.446247 15.09C0.562482 15.2008 0.716908 15.2626 0.877496 15.2626C1.03808 15.2626 1.19251 15.2008 1.30875 15.09L8.275 8.45249C8.33626 8.39411 8.38504 8.32391 8.41836 8.24613C8.45169 8.16834 8.46887 8.08461 8.46887 7.99998C8.46887 7.91536 8.45169 7.83162 8.41836 7.75384C8.38504 7.67606 8.33626 7.60586 8.275 7.54748Z" fill="black" />
                    </svg>
                    <a className='text-primary-400 ' href='explore'>Explore</a>
                </div>
            </div>

            <div className="mx-auto p-2 text-lg md:text-xl font-semibold">Indonesia Global Socioeconomic Position Research Center</div>

            <div className="row mx-auto p-4">
                {/* ===mobile screen=== */}
                <div className={`bg-gray-200 dropdown ${isDropdownOpen ? "" : "sm:hidden"} rounded-lg `}>
                    <button
                        className="btn btn-secondary p-2 rounded-xl bg-gray-300 dropdown-toggle w-full font-semibold text-black"
                        type="button"
                        id="dropdownMenuButton"
                        data-bs-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                        onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                    >
                        {selectedOption}
                    </button>
                    <div
                        className={`text-black m-4 dropdown-menu max-h-[50vh] overflow-y-auto ${isDropdownOpen ? "block" : "hidden"
                            } rounded-lg`}
                        aria-labelledby="dropdownMenuButton"
                    >
                        <div className="dropdown-item" onClick={() => handleOptionSelect("Socioeconomic Performance Index")}>
                            <label htmlFor="SEPX">Socioeconomic Performance Index</label>
                        </div>
                        <div className="dropdown-item" onClick={() => handleOptionSelect("Macroeconomic Stability")}>
                            <label htmlFor="macroStab">Macroeconomic Stability</label>
                        </div>
                        <div className="dropdown-item" onClick={() => handleOptionSelect("Price Stability")}>
                            <label htmlFor="priceStab">Price Stability</label>
                        </div>
                        <div className="dropdown-item" onClick={() => handleOptionSelect("Level of Employment")}>
                            <label htmlFor="empLev">Level of Employment</label>
                        </div>
                        <div className="dropdown-item" onClick={() => handleOptionSelect("Fiscal Health")}>
                            <label htmlFor="fiscHealth">Fiscal Health</label>
                        </div>
                        <div className="dropdown-item" onClick={() => handleOptionSelect("Favorable Trade Balance")}>
                            <label htmlFor="favTradeBal">Favorable Trade Balance</label>
                        </div>
                        <div className="dropdown-item" onClick={() => handleOptionSelect("Microeconomic Competitiveness")}>
                            <label htmlFor="microComp">Microeconomic Competitiveness</label>
                        </div>
                        <div className="dropdown-item" onClick={() => handleOptionSelect("Trade Competitiveness")}>
                            <label htmlFor="tradeComp">Trade Competitiveness</label>
                        </div>
                        <div className="dropdown-item" onClick={() => handleOptionSelect("Openness to Imports")}>
                            <label htmlFor="openToImp">Openness to Imports</label>
                        </div>
                        <div className="dropdown-item" onClick={() => handleOptionSelect("Political Responsiveness")}>
                            <label htmlFor="polResp">Political Responsiveness</label>
                        </div>
                        <div className="dropdown-item" onClick={() => handleOptionSelect("Total Factor Productivity")}>
                            <label htmlFor="tfp">Total Factor Productivity</label>
                        </div>
                        <div className="dropdown-item" onClick={() => handleOptionSelect("Social Cohesion")}>
                            <label htmlFor="socCoh">Social Cohesion</label>
                        </div>
                        <div className="dropdown-item" onClick={() => handleOptionSelect("Social Security")}>
                            <label htmlFor="socSec">Social Security</label>
                        </div>
                        <div className="dropdown-item" onClick={() => handleOptionSelect("Personal Safety")}>
                            <label htmlFor="persSafe">Personal Safety</label>
                        </div>
                        <div className="dropdown-item" onClick={() => handleOptionSelect("Gender Equality")}>
                            <label htmlFor="genderEqual">Gender Equality</label>
                        </div>
                        <div className="dropdown-item" onClick={() => handleOptionSelect("Equitable Social Development")}>
                            <label htmlFor="equitSocDev">Equitable Social Development</label>
                        </div>
                        <div className="dropdown-item" onClick={() => handleOptionSelect("Human Empowerment")}>
                            <label htmlFor="humEmp">Human Empowerment</label>
                        </div>
                        <div className="dropdown-item" onClick={() => handleOptionSelect("Scientific Output")}>
                            <label htmlFor="scientificOut">Scientific Output</label>
                        </div>
                        <div className="dropdown-item" onClick={() => handleOptionSelect("School Enrollment")}>
                            <label htmlFor="schoolEnr">School Enrollment</label>
                        </div>
                        <div className="dropdown-item" onClick={() => handleOptionSelect("Infant Survivability")}>
                            <label htmlFor="infSurv">Infant Survivability</label>
                        </div>
                        <div className="dropdown-item" onClick={() => handleOptionSelect("Public Health")}>
                            <label htmlFor="pubHealth">Public Health</label>
                        </div>
                        <div className="dropdown-item" onClick={() => handleOptionSelect("Environmental Sustainability")}>
                            <label htmlFor="envSust">Environmental Sustainability</label>
                        </div>
                        <div className="dropdown-item" onClick={() => handleOptionSelect("Nature Conservation")}>
                            <label htmlFor="natureCons">Nature Conservation</label>
                        </div>
                        <div className="dropdown-item" onClick={() => handleOptionSelect("Access to Safe Water")}>
                            <label htmlFor="safeWatAcc">Access to Safe Water</label>
                        </div>
                        <div className="dropdown-item mb-4" onClick={() => handleOptionSelect("Natural Disaster Resilience")}>
                            <label htmlFor="natDisRes">Natural Disaster Resilience</label>
                        </div>
                    </div>
                </div>

                {/* ===web screen=== */}
                <div className="container mx-auto p-4">
                    <div className="grid grid-cols-1 md:grid-cols-3 md:gap-4 items-left text-left">

                        <div className="col-span-1 hidden sm:block">

                            <div className="grid grid-cols-4 gap-2 items-left text-left">
                                <div className="col-span-3">
                                    <label className="container concept font-semibold">Socioeconomic Performance Index</label>
                                </div>

                                <div className="col-span-1 items-right text-right md:text-center">
                                    <input className="indListForWrldMap" onClick={getIdForWrldMap} type="radio" name="radio" id="SEPX" defaultChecked />
                                    <span className="checkmark"></span>
                                </div>
                            </div>

                            <div className="grid grid-cols-4 gap-2 items-left text-left mt-2">
                                <div className="col-span-3">
                                    <label className="container concept font-semibold">Macroeconomic Stability</label>
                                </div>

                                <div className="col-span-1 items-right text-right md:text-center">
                                    <input className="indListForWrldMap" onClick={getIdForWrldMap} type="radio" name="radio" id="macroStab" />
                                    <span className="checkmark"></span>
                                </div>
                            </div>

                            <div className="grid grid-cols-4 gap-2 items-left text-left">
                                <div className="col-span-3 md:pl-4">
                                    <label className="container subConcept">Price Stability</label>
                                </div>

                                <div className="col-span-1 items-right text-right md:text-center">
                                    <input className="indListForWrldMap" onClick={getIdForWrldMap} type="radio" name="radio" id="priceStab" />
                                    <span className="checkmark"></span>
                                </div>
                            </div>

                            <div className="grid grid-cols-4 gap-2 items-left text-left">
                                <div className="col-span-3 md:pl-4">
                                    <label className="container subConcept">Level of Employment</label>
                                </div>

                                <div className="col-span-1 items-right text-right md:text-center">
                                    <input className="indListForWrldMap" onClick={getIdForWrldMap} type="radio" name="radio" id="empLev" />
                                    <span className="checkmark"></span>
                                </div>
                            </div>

                            <div className="grid grid-cols-4 gap-2 items-left text-left">
                                <div className="col-span-3 md:pl-4">
                                    <label className="container subConcept">Fiscal Health</label>
                                </div>

                                <div className="col-span-1 items-right text-right md:text-center">
                                    <input className="indListForWrldMap" onClick={getIdForWrldMap} type="radio" name="radio" id="fiscHealth" />
                                    <span className="checkmark"></span>
                                </div>
                            </div>

                            <div className="grid grid-cols-4 gap-2 items-left text-left">
                                <div className="col-span-3 md:pl-4">
                                    <label className="container subConcept">Favorable Trade Balance</label>
                                </div>

                                <div className="col-span-1 items-right text-right md:text-center">
                                    <input className="indListForWrldMap" onClick={getIdForWrldMap} type="radio" name="radio" id="favTradeBal" />
                                    <span className="checkmark"></span>
                                </div>
                            </div>

                            <div className="grid grid-cols-4 gap-2 items-left text-left mt-2">
                                <div className="col-span-3">
                                    <label className="container concept font-semibold">Microeconomic Competitiveness</label>
                                </div>

                                <div className="col-span-1 items-right text-right md:text-center">
                                    <input className="indListForWrldMap" onClick={getIdForWrldMap} type="radio" name="radio" id="microComp" />
                                    <span className="checkmark"></span>
                                </div>
                            </div>

                            <div className="grid grid-cols-4 gap-2 items-left text-left">
                                <div className="col-span-3 md:pl-4">
                                    <label className="container subConcept">Trade Competitiveness</label>
                                </div>

                                <div className="col-span-1 items-right text-right md:text-center">
                                    <input className="indListForWrldMap" onClick={getIdForWrldMap} type="radio" name="radio" id="tradeComp" />
                                    <span className="checkmark"></span>
                                </div>
                            </div>

                            <div className="grid grid-cols-4 gap-2 items-left text-left">
                                <div className="col-span-3 md:pl-4">
                                    <label className="container subConcept">Openess to Imports</label>
                                </div>

                                <div className="col-span-1 items-right text-right md:text-center">
                                    <input className="indListForWrldMap" onClick={getIdForWrldMap} type="radio" name="radio" id="openToImp" />
                                    <span className="checkmark"></span>
                                </div>
                            </div>

                            <div className="grid grid-cols-4 gap-2 items-left text-left">
                                <div className="col-span-3 md:pl-4">
                                    <label className="container subConcept">Political Responsiveness</label>
                                </div>

                                <div className="col-span-1 items-right text-right md:text-center">
                                    <input className="indListForWrldMap" onClick={getIdForWrldMap} type="radio" name="radio" id="polResp" />
                                    <span className="checkmark"></span>
                                </div>
                            </div>

                            <div className="grid grid-cols-4 gap-2 items-left text-left">
                                <div className="col-span-3 md:pl-4">
                                    <label className="container subConcept">Total Factor Productivity</label>
                                </div>

                                <div className="col-span-1 items-right text-right md:text-center">
                                    <input className="indListForWrldMap" onClick={getIdForWrldMap} type="radio" name="radio" id="tfp" />
                                    <span className="checkmark"></span>
                                </div>
                            </div>

                            <div className="grid grid-cols-4 gap-2 items-left text-left mt-2">
                                <div className="col-span-3">
                                    <label className="container concept font-semibold">Social Cohesion</label>
                                </div>

                                <div className="col-span-1 items-right text-right md:text-center">
                                    <input className="indListForWrldMap" onClick={getIdForWrldMap} type="radio" name="radio" id="socCoh" />
                                    <span className="checkmark"></span>
                                </div>
                            </div>

                            <div className="grid grid-cols-4 gap-2 items-left text-left">
                                <div className="col-span-3 md:pl-4">
                                    <label className="container subConcept">Social Security</label>
                                </div>

                                <div className="col-span-1 items-right text-right md:text-center">
                                    <input className="indListForWrldMap" onClick={getIdForWrldMap} type="radio" name="radio" id="socSec" />
                                    <span className="checkmark"></span>
                                </div>
                            </div>

                            <div className="grid grid-cols-4 gap-2 items-left text-left">
                                <div className="col-span-3 md:pl-4">
                                    <label className="container subConcept">Personal Safety</label>
                                </div>

                                <div className="col-span-1 items-right text-right md:text-center">
                                    <input className="indListForWrldMap" onClick={getIdForWrldMap} type="radio" name="radio" id="persSafe" />
                                    <span className="checkmark"></span>
                                </div>
                            </div>

                            <div className="grid grid-cols-4 gap-2 items-left text-left">
                                <div className="col-span-3 md:pl-4">
                                    <label className="container subConcept">Gender Equality</label>
                                </div>

                                <div className="col-span-1 items-right text-right md:text-center">
                                    <input className="indListForWrldMap" onClick={getIdForWrldMap} type="radio" name="radio" id="genderEqual" />
                                    <span className="checkmark"></span>
                                </div>
                            </div>

                            <div className="grid grid-cols-4 gap-2 items-left text-left">
                                <div className="col-span-3 md:pl-4">
                                    <label className="container subConcept">Equitable Social Development</label>
                                </div>

                                <div className="col-span-1 items-right text-right md:text-center">
                                    <input className="indListForWrldMap" onClick={getIdForWrldMap} type="radio" name="radio" id="equitSocDev" />
                                    <span className="checkmark"></span>
                                </div>
                            </div>

                            <div className="grid grid-cols-4 gap-2 items-left text-left mt-2">
                                <div className="col-span-3">
                                    <label className="container concept font-semibold">Human Empowerment</label>
                                </div>

                                <div className="col-span-1 items-right text-right md:text-center">
                                    <input className="indListForWrldMap" onClick={getIdForWrldMap} type="radio" name="radio" id="humEmp" />
                                    <span className="checkmark"></span>
                                </div>
                            </div>

                            <div className="grid grid-cols-4 gap-2 items-left text-left">
                                <div className="col-span-3 md:pl-4">
                                    <label className="container subConcept">Scientific Output</label>
                                </div>

                                <div className="col-span-1 items-right text-right md:text-center">
                                    <input className="indListForWrldMap" onClick={getIdForWrldMap} type="radio" name="radio" id="scientificOut" />
                                    <span className="checkmark"></span>
                                </div>
                            </div>

                            <div className="grid grid-cols-4 gap-2 items-left text-left">
                                <div className="col-span-3 md:pl-4">
                                    <label className="container subConcept">School Enrollment</label>
                                </div>

                                <div className="col-span-1 items-right text-right md:text-center">
                                    <input className="indListForWrldMap" onClick={getIdForWrldMap} type="radio" name="radio" id="schoolEnr" />
                                    <span className="checkmark"></span>
                                </div>
                            </div>

                            <div className="grid grid-cols-4 gap-2 items-left text-left">
                                <div className="col-span-3 md:pl-4">
                                    <label className="container subConcept">Infant Survivability</label>
                                </div>

                                <div className="col-span-1 items-right text-right md:text-center">
                                    <input className="indListForWrldMap" onClick={getIdForWrldMap} type="radio" name="radio" id="infSurv" />
                                    <span className="checkmark"></span>
                                </div>
                            </div>

                            <div className="grid grid-cols-4 gap-2 items-left text-left">
                                <div className="col-span-3 md:pl-4">
                                    <label className="container subConcept">Public Health</label>
                                </div>

                                <div className="col-span-1 items-right text-right md:text-center">
                                    <input className="indListForWrldMap" onClick={getIdForWrldMap} type="radio" name="radio" id="pubHealth" />
                                    <span className="checkmark"></span>
                                </div>
                            </div>

                            <div className="grid grid-cols-4 gap-2 items-left text-left mt-2">
                                <div className="col-span-3">
                                    <label className="container concept font-semibold">Environmental Sustainability</label>
                                </div>

                                <div className="col-span-1 items-right text-right md:text-center">
                                    <input className="indListForWrldMap" onClick={getIdForWrldMap} type="radio" name="radio" id="envSust" />
                                    <span className="checkmark"></span>
                                </div>
                            </div>

                            <div className="grid grid-cols-4 gap-2 items-left text-left">
                                <div className="col-span-3 md:pl-4">
                                    <label className="container subConcept">Nature Conservation</label>
                                </div>

                                <div className="col-span-1 items-right text-right md:text-center">
                                    <input className="indListForWrldMap" onClick={getIdForWrldMap} type="radio" name="radio" id="natureCons" />
                                    <span className="checkmark"></span>
                                </div>
                            </div>


                            <div className="grid grid-cols-4 gap-2 items-left text-left">
                                <div className="col-span-3 md:pl-4">
                                    <label className="container subConcept">Access to Safe Water</label>
                                </div>

                                <div className="col-span-1 items-right text-right md:text-center">
                                    <input className="indListForWrldMap" onClick={getIdForWrldMap} type="radio" name="radio" id="safeWatAcc" />
                                    <span className="checkmark"></span>
                                </div>
                            </div>

                            <div className="grid grid-cols-4 gap-2 items-left text-left">
                                <div className="col-span-3 md:pl-4">
                                    <label className="container subConcept">Access to Clean Air</label>
                                </div>

                                <div className="col-span-1 items-right text-right md:text-center">
                                    <input className="indListForWrldMap" onClick={getIdForWrldMap} type="radio" name="radio" id="cleanAirAcc" />
                                    <span className="checkmark"></span>
                                </div>
                            </div>

                            <div className="grid grid-cols-4 gap-2 items-left text-left">
                                <div className="col-span-3 md:pl-4">
                                    <label className="container subConcept">Natural Disaster Resilience</label>
                                </div>

                                <div className="col-span-1 items-right text-right md:text-center">
                                    <input className="indListForWrldMap" onClick={getIdForWrldMap} type="radio" name="radio" id="natDisRes" />
                                    <span className="checkmark"></span>
                                </div>
                            </div>
                        </div>

                        <div className="col-span-2">
                            <div id="regions_div"></div>
                            {/* <div>indicator : {indWorldmap}</div>
                            <div>year : {year}</div>
                            <div>ranking 1 {alpha2}</div> */}
                            <Chart
                                chartEvents={[
                                    {
                                        eventName: "select",
                                        callback: ({ chartWrapper }) => {
                                            const chart = chartWrapper.getChart();
                                            const selection = chart.getSelection();
                                            console.log('HALOOOOOOOOOOOOO')
                                            if (selection.length === 0) return;
                                            const region = data[selection[0].row + 1];
                                            console.log(data[selection[0].row + 1])
                                            console.log('Haloooooooooooooo')
                                            console.log("Selected : " + region);
                                        },
                                    },
                                ]}
                                chartType="GeoChart"
                                width="100%"
                                height="auto"
                                data={worldMap}
                                options={optionmaps}

                            />

                            <input type="range" min="1990" max="2022" step="1" id="sliderWorld" defaultValue={year} onChange={getYear} className="w-full mt-8" />
                            <div className="sliderTicks flex">
                                <div className="year">
                                    <p className="md:text-base text-[10px]">1990</p>
                                </div>
                                <div className="year">
                                    <p className="md:text-base text-[10px]">1991</p>
                                </div>
                                <div className="year">
                                    <p className="md:text-base text-[10px]">1992</p>
                                </div>
                                <div className="year">
                                    <p className="md:text-base text-[10px]">1993</p>
                                </div>
                                <div className="year">
                                    <p className="md:text-base text-[10px]">1994</p>
                                </div>
                                <div className="year">
                                    <p className="md:text-base text-[10px]">1995</p>
                                </div>
                                <div className="year">
                                    <p className="md:text-base text-[10px]">1996</p>
                                </div>
                                <div className="year">
                                    <p className="md:text-base text-[10px]">1997</p>
                                </div>
                                <div className="year">
                                    <p className="md:text-base text-[10px]">1998</p>
                                </div>
                                <div className="year">
                                    <p className="md:text-base text-[10px]">1999</p>
                                </div>
                                <div className="year">
                                    <p className="md:text-base text-[10px]">2000</p>
                                </div>
                                <div className="year">
                                    <p className="md:text-base text-[10px]">2001</p>
                                </div>
                                <div className="year">
                                    <p className="md:text-base text-[10px]">2002</p>
                                </div>
                                <div className="year">
                                    <p className="md:text-base text-[10px]">2003</p>
                                </div>
                                <div className="year">
                                    <p className="md:text-base text-[10px]">2004</p>
                                </div>
                                <div className="year">
                                    <p className="md:text-base text-[10px]">2005</p>
                                </div>
                                <div className="year">
                                    <p className="md:text-base text-[10px]">2006</p>
                                </div>
                                <div className="year">
                                    <p className="md:text-base text-[10px]">2007</p>
                                </div>
                                <div className="year">
                                    <p className="md:text-base text-[10px]">2008</p>
                                </div>
                                <div className="year">
                                    <p className="md:text-base text-[10px]">2009</p>
                                </div>
                                <div className="year">
                                    <p className="md:text-base text-[10px]">2010</p>
                                </div>
                                <div className="year">
                                    <p className="md:text-base text-[10px]">2011</p>
                                </div>
                                <div className="year">
                                    <p className="md:text-base text-[10px]">2012</p>
                                </div>
                                <div className="year">
                                    <p className="md:text-base text-[10px]">2013</p>
                                </div>
                                <div className="year">
                                    <p className="md:text-base text-[10px]">2014</p>
                                </div>
                                <div className="year">
                                    <p className="md:text-base text-[10px]">2015</p>
                                </div>
                                <div className="year">
                                    <p className="md:text-base text-[10px]">2016</p>
                                </div>
                                <div className="year">
                                    <p className="md:text-base text-[10px]">2017</p>
                                </div>
                                <div className="year">
                                    <p className="md:text-base text-[10px]">2018</p>
                                </div>
                                <div className="year">
                                    <p className="md:text-base text-[10px]">2019</p>
                                </div>
                                <div className="year">
                                    <p className="md:text-base text-[10px]">2020</p>
                                </div>
                                <div className="year">
                                    <p className="md:text-base text-[10px]">2021</p>
                                </div>
                                <div className="year">
                                    <p className="md:text-base text-[10px]">2022</p>
                                </div>
                            </div>




                        </div>
                    </div>
                </div>

            </div>

        </>
    )
}

export default Explore;